module.exports = __webpack_public_path__ + "static/incre-modal-icon.f3131013.png";